import { Card, CardBody, CardHeader, CardTitle, Container } from 'reactstrap';
import './Projects.css';
import Carousel from './Carousel';

function Projects() {

  return (
    <Container id="projects" className="my-5">
      <Card>
        <CardHeader>
          <CardTitle tag="h2">
            Projects:
          </CardTitle>
        </CardHeader>
        <CardBody>
          <Carousel />
        </CardBody>
      </Card>
    </Container>
  );
}

export default Projects;